<template>
  <div class="camo-background-hack">
    <Home/>
  </div>
</template>

<script>
  import store from '../lib/store';
  import settings from '../settings/kuiuanchorage';
  import Home from '../pages/HomeQuick';


  export default {
    name: 'KUIUAnchorage',
    components: {
      Home,
    },
    created() {
      store.set('subscription', settings.subscription);
      store.set('mailing_list', settings.mailing_list);
      store.set('info_url', settings.info_url);
      store.set('title_in_progress', settings.title.in_progress);
      store.set('title_success', settings.title.success);
      store.set('title_subtext', settings.title.subtext);
      store.set('cancel_anytime', settings.cancel_anytime);
      store.set('review_agreement', settings.review.agreement);
      store.set('review_summary', settings.review.summary);
      store.set('review_button_text', settings.review.button_text);
      store.set('review_title', settings.review.title);
    },
  };

</script>

<style>
  .camo-background-hack {
    background-image: url('../assets/images/kuiuanchorage_background.png') !important;
    background-repeat: repeat;
    min-height: 100vh;
  }
</style>


// WEBPACK FOOTER //
// KUIUAnchorage.vue?4a1c4347